<mat-dialog-content class="flag-container" fxLayout="row" fxLayoutAlign="center center">
  <span class="close-icon"><close-svg (click)="this.dialog.close(null);" /></span>
  <table>
    @for (language of data; track language) {
      <tr (click)="selectLanguage(language.code)" class="hw-cursor-pointer">
        <td class="hw-text-align-center">
          <img [src]="language.flagUrl" height="30" width="46" class="language-flag-style" />
        </td>
        <td>
          {{language.customName}}
        </td>
      </tr>
    }
  </table>

</mat-dialog-content>
